import { apiClient } from './api';
import type { ApiResponse, Contact, ContactFilters, PaginatedResponse } from '@/types';

export async function listContacts(params?: ContactFilters): Promise<ApiResponse<PaginatedResponse<Contact>>> {
  return apiClient.getPaginated<Contact>('/contacts', params);
}

export interface UpdateContactRequest {
  name?: string;
  email?: string;
  tags?: string[];
  opt_in?: boolean;
  metadata?: Record<string, any>;
}

export async function updateContact(id: string, payload: UpdateContactRequest): Promise<ApiResponse<Contact>> {
  return apiClient.put<Contact>(`/contacts/${id}`, payload);
}
